var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyboardArrowLeftOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.70175 12.7018L14.7018 7.70175C14.8947 7.52632 15 7.2807 15 7C15 6.45614 14.5439 6 14 6C13.7193 6 13.4737 6.10526 13.2982 6.29825L8.29825 11.2982C8.10526 11.4737 8 11.7193 8 12C8 12.5439 8.45614 13 9 13C9.2807 13 9.52632 12.8947 9.70175 12.7018ZM14.7018 16.2982L9.70175 11.2982C9.52632 11.1053 9.2807 11 9 11C8.45614 11 8 11.4561 8 12C8 12.2807 8.10526 12.5263 8.29825 12.7018L13.2982 17.7018C13.4737 17.8947 13.7193 18 14 18C14.5439 18 15 17.5439 15 17C15 16.7193 14.8947 16.4737 14.7018 16.2982Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowLeftOutlined);
export default __webpack_public_path__ + "static/media/keyboard_arrow_left_outlined.62642699.svg";
export { ForwardRef as ReactComponent };